import { render } from "./ByosNavigation.vue?vue&type=template&id=5733e5c3"
import script from "./ByosNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosNavigation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5733e5c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5733e5c3', __exports__)) {
    api.reload('5733e5c3', __exports__)
  }
  
  module.hot.accept("./ByosNavigation.vue?vue&type=template&id=5733e5c3", () => {
    api.rerender('5733e5c3', render)
  })

}


export default __exports__